import { render } from "./winRate.vue?vue&type=template&id=54b610e7&scoped=true&ts=true"
import script from "./winRate.vue?vue&type=script&lang=ts"
export * from "./winRate.vue?vue&type=script&lang=ts"

import "./winRate.vue?vue&type=style&index=0&id=54b610e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b610e7"]])

export default __exports__